export function buildProductSearchQuery(filters, page = 0) {
    const params = new URLSearchParams({ offset: String(page) });

    if (filters.search?.trim()) {
        params.set("search", filters.search.trim());
    }
    if (filters.category) {
        params.set("category", filters.category);
    }
    if (filters.lotName?.trim()) {
        params.set("lotName", filters.lotName.trim());
    }
    if (filters.status) {
        params.set("status", filters.status);
    }
    if (filters.stock) {
        params.set("stock", filters.stock);
    }
    if (filters.priceMin !== "" && filters.priceMin != null) {
        params.set("priceMin", String(filters.priceMin));
    }
    if (filters.priceMax !== "" && filters.priceMax != null) {
        params.set("priceMax", String(filters.priceMax));
    }

    return params;
}

export function buildLotSearchQuery(filters, page = 0) {
    const params = new URLSearchParams({ offset: String(page) });

    if (filters.search?.trim()) {
        params.set("search", filters.search.trim());
    }
    if (filters.status) {
        params.set("status", filters.status);
    }
    if (filters.productId) {
        params.set("productId", filters.productId);
    }

    return params;
}
